"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./CustomTypeaheadInput.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _reactBootstrapTypeahead = require("react-bootstrap-typeahead");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _CustomError = _interopRequireDefault(require("./CustomError"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _ApiGetter = _interopRequireDefault(require("../../../shared/models/ApiGetter"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CustomForm = require("./CustomForm");

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var CustomTypeaheadInput = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomTypeaheadInput, _React$Component);

  var _super = _createSuper(CustomTypeaheadInput);

  function CustomTypeaheadInput() {
    var _this;

    _classCallCheck(this, CustomTypeaheadInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "serverOptions", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "selected", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "displaySearchOptions", _descriptor3, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(CustomTypeaheadInput, [{
    key: "renderableOptions",
    get: function get() {
      var options = this.props.options.slice();
      return (0, _isEmpty.default)(options) ? (0, _mobx.toJS)(this.serverOptions) : options;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var dispatcher = this.props.dispatcher;
      var apiGetter = new _ApiGetter.default(dispatcher);

      if ((0, _isEmpty.default)(this.props.options.slice()) && !(0, _isEmpty.default)(this.props.endpoint) && !(0, _isUndefined.default)(dispatcher)) {
        apiGetter.fetch(this.props.endpoint, function (res) {
          _this2.serverOptions = res;
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.selected = this.props.value ? [this.props.value] : [];
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(selectedOption, e) {
      this.selected = selectedOption ? [selectedOption] : [];

      if (!selectedOption) {
        return;
      }

      var value = this.props.outConverter(selectedOption);
      this.context.form.set(this.props.fieldName, value);

      if ((0, _isFunction.default)(this.props.onOptionSelected)) {
        this.props.onOptionSelected(selectedOption, e);
      }

      this.displaySearchOptions = false;
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if ((0, _isEmpty.default)(e.target.value) && !(0, _isEmpty.default)(this.context.form.get(this.props.fieldName))) {
        this.context.form.set(this.props.fieldName, "");
      }

      if ((0, _isFunction.default)(this.props.onBlur)) {
        this.props.onBlur(e);
      }

      this.displaySearchOptions = false;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if ((0, _isFunction.default)(this.props.onFocus)) {
        this.props.onFocus(e);
      }

      if (this.props.showOptionsOnInputSelect) {
        this.displaySearchOptions = true;
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      this.displaySearchOptions = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var inputId = "typeahead-".concat(this.props.fieldName);
      var errors = this.context.form.errors.get(this.props.fieldName);
      var containerClasses = (0, _classnames.default)("custom-typeahead", "input-container", {
        "has-errors": !(0, _isUndefined.default)(errors) && !(0, _isEmpty.default)(errors.slice())
      }, this.props.className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClasses
      }, !(0, _isEmpty.default)(this.props.label) && /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: inputId
      }, this.props.label), /*#__PURE__*/_react.default.createElement(_reactBootstrapTypeahead.Typeahead, {
        onKeyDown: this.handleKeyDown,
        open: this.displaySearchOptions,
        options: this.renderableOptions,
        labelKey: this.props.labelKey,
        maxResults: this.props.maxVisible,
        filterBy: this.props.filterBy,
        renderMenu: this.props.renderTypeaheadMenu,
        placeholder: this.props.placeholder,
        defaultInputValue: this.props.initialValue,
        emptyLabel: this.props.emptyLabel && this.props.emptyLabel,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        disabled: this.props.disabled // NOTE: The Typeahead library provides the ability to handle multiple selected options, but
        // since we don't have that functionality on the site now we default to one
        // selected option.
        ,
        onChange: function onChange(options) {
          return _this3.handleChange(options[0]);
        },
        selected: this.selected.slice(),
        id: this.props.id // NOTE: The Typeahead library provides the ability to "display additional results", but for now
        // we are disabling that functionality alltogether across anything that makes use of this component.
        // If needed, it can easily be implemented.
        ,
        paginate: false
      }), /*#__PURE__*/_react.default.createElement(_CustomError.default, {
        errors: errors
      }));
    }
  }]);

  return CustomTypeaheadInput;
}(_react.default.Component), _defineProperty(_class3, "contextType", _CustomForm.CustomFormContext), _defineProperty(_class3, "propTypes", {
  dispatcher: _propTypes.default.object.isRequired,
  fieldName: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  labelKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  label: _propTypes.default.string,
  className: _propTypes.default.string,
  initialValue: _propTypes.default.string,
  options: _mobxReact.PropTypes.arrayOrObservableArray,
  endpoint: _propTypes.default.string,
  emptyLabel: _propTypes.default.node,
  placeholder: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  maxVisible: _propTypes.default.number,
  outConverter: _propTypes.default.func,
  searchOptions: _propTypes.default.func,
  filterBy: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.func]),
  onOptionSelected: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  renderTypeaheadMenu: _propTypes.default.func
}), _defineProperty(_class3, "defaultProps", {
  maxVisible: 3,
  //expected data format is a SelectOptionViewModel.cs
  options: [],
  initialValue: "",
  labelKey: "label",
  filterBy: ["label"],
  outConverter: function outConverter(option) {
    return option ? option.value : option;
  },
  disabled: false,
  renderTypeaheadMenu: undefined
}), _class3), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "serverOptions", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selected", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "displaySearchOptions", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "renderableOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "renderableOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleBlur", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleBlur"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleFocus", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleFocus"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleKeyDown", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleKeyDown"), _class2.prototype)), _class2)) || _class;

var _default = CustomTypeaheadInput;
exports.default = _default;